import useValidation from "../../hooks/useValidation"
import { useEffect, useState } from "react"
import individualWithFamilySituationVAlidationSchema from "../../utils/validation/individualWithFamilySituationValidationSchema"
import { format, isValid, parse } from "date-fns"
import { PreviousMaritalRegimeType } from "../../static/types/commonTypes/previousMaritalRegimeType"
import previousMaritalRegimeValidationSchema from "../../utils/validation/previousMaritalRegimeValidationSchema"

type MaritalRegimeProps = {
    checked: boolean,
    maritalRegime: PreviousMaritalRegimeType,
    changeMaritalRegime: ( maritalRegime: Partial<PreviousMaritalRegimeType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function MeritalRegime ({
    checked,
    maritalRegime,
    changeMaritalRegime,
    onValidationChange
}: MaritalRegimeProps ) {

    const { errors, isValid: isDataValid } = useValidation( maritalRegime, previousMaritalRegimeValidationSchema )

    useEffect( () => {
        onValidationChange( isDataValid )
    }, [ isDataValid, onValidationChange ])

    
        const [ weddingDate, setWeddingDate ] = useState<string>("");
    
        useEffect(() => {
            if (maritalRegime.weddingDate) {
                const parsedDate = parse(maritalRegime.weddingDate, "dd/MM/yyyy", new Date());
                setWeddingDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
            }
        }, [ maritalRegime ]);
    
        const handleActeDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const inputDate = e.target.value;
            const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
            const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";
    
            setWeddingDate(inputDate);
            changeMaritalRegime({ weddingDate: formattedDate });
        };
    
        const openDatePicker = (id: string) => {
            const input = document.getElementById(id) as HTMLInputElement;
            input?.showPicker();
        };

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "previousRegime" className = "col-sm-2 col-form-label">Régime matrimonial <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-10">
                    <select
                        className = { `form-select ${ ( checked && errors.previousRegime ) ? 'is-invalid' : ''}` }
                        name = "previousRegime"
                        id = "previousRegime"
                        onChange = { event => changeMaritalRegime({ previousRegime: event.target.value as "Communauté de biens réduite aux acquêts" | "Séparation de biens" | "Communauté universelle" | "Participation aux acquêts"}) }
                    >
                        {
                            [
                                "Communauté de biens réduite aux acquêts",
                                "Séparation de biens",
                                "Communauté universelle",
                                "Participation aux acquêts"
                            ].map( ( previousRegime, key )  => 
                                <option key = { key } value = { previousRegime }>
                                    { previousRegime }
                                </option>
                            )
                        }
                    </select>
                    {( checked && errors.previousRegime ) && <div className="invalid-feedback"> { errors.previousRegime } </div> }

                </div>
                
            </div>

            <div className = "mb-3 row">

                <label htmlFor="weddingDate" className="col-sm-2 col-form-label"> Date du mariage <strong className="text-danger">*</strong> </label>
    
                <div className="col-sm-10 mb-3">
                    <input
                        className={ `form-control ${ ( checked && errors.weddingDate ) ? 'is-invalid' : ''}` }
                        type="date"
                        id="weddingDate"
                        value={weddingDate}
                        onChange={handleActeDateChange}
                        onClick={() => openDatePicker("weddingDate")}
                        placeholder="JJ/MM/AAAA"
                    />
                    {( checked && errors.weddingDate ) && <div className="invalid-feedback"> { errors.weddingDate } </div> }
                </div>

            </div>

            <div className = "mb-3 row">

                <label htmlFor = "weddingPlace" className = "col-sm-2 col-form-label"> Lieu du mariage <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <input
                        className = { `form-control ${ ( checked && errors.weddingPlace ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "weddingPlace"
                        value = { maritalRegime.weddingPlace }
                        onChange = { event => changeMaritalRegime({ weddingPlace: event.target.value })}
                    />
                    {( checked && errors.weddingPlace ) && <div className="invalid-feedback"> { errors.weddingPlace } </div> }

                </div>

            </div>


        </div>
    )
}